import React from "react";

import "./WeatherInfo.css";

import FormattedMonth from "./FormattedMonth";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <div className="row">
        <div className="col">
          <h2>
            {props.data.city}, {props.data.country}
          </h2>
          <ul>
            <li>
              Last update: <FormattedMonth timestamp={props.data.date} />
            </li>
            <li className="weather-description">{props.data.description}</li>
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="col-6 showTemperature">
          <div className="temperature icon">
            <WeatherIcon info={props.data.icon} />
            <WeatherTemperature celsius={props.data.temperature} />
          </div>
        </div>
        <div className="col-6 metrics-description showTemperature">
          <ul>
            <li>
              Humidity:{" "}
              <span className="highlights">{props.data.humidity}%</span>
            </li>
            <li>
              Wind: <span className="highlights">{props.data.wind} m/sec</span>
            </li>
            <li>
              Pressure:{" "}
              <span className="highlights">{props.data.pressure} hPa </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
